// "2 DAYS AGO" — the loop shows recency rather than a calendar date, so the timestamp
// reads as context instead of metadata.
const formatRelativeAge = (value?: string | null): string | null => {
  if (!value) return null;

  const timestamp = new Date(value).getTime();
  if (Number.isNaN(timestamp)) return null;

  const minutes = Math.floor((Date.now() - timestamp) / 60_000);
  if (minutes < 1) return 'JUST NOW';
  if (minutes < 60) return `${minutes} MIN AGO`;

  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours} ${hours === 1 ? 'HOUR' : 'HOURS'} AGO`;

  const days = Math.floor(hours / 24);
  if (days < 30) return `${days} ${days === 1 ? 'DAY' : 'DAYS'} AGO`;

  const months = Math.floor(days / 30);
  if (months < 12) return `${months} ${months === 1 ? 'MONTH' : 'MONTHS'} AGO`;

  const years = Math.floor(months / 12);

  return `${years} ${years === 1 ? 'YEAR' : 'YEARS'} AGO`;
};

export default formatRelativeAge;
